module.exports = __webpack_public_path__ + "img/c71e5ba.png";